<script setup lang="ts">

const props = defineProps<{
  lock?: boolean
}>()

onMounted(() => {
  const body = document.querySelector("body")
  if (body && props.lock) {
    body.scrollTop = 0
    body.style.overflow = "hidden"
  }
})

onUnmounted(() => {
  const body = document.querySelector("body")
  if (body && props.lock) {
    body.style.overflow = "auto"
  }
})
</script>

<template>
  <teleport
    to="body"
  >
    <slot />
  </teleport>
</template>
